// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const DeleteBucketDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-deletebucketdialogcontainer" */ "./DeleteBucketDialogContainer")).then((bundle)=>{
        return {
            default: bundle.DeleteBucketDialogContainer
        };
    });
export const LazyDeleteBucketDialogContainer = /*#__PURE__*/ lazy(DeleteBucketDialogContainerLazyLoader);
